var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('codemirror',{staticClass:"codemirror-main",staticStyle:{"height":"100%"},attrs:{"options":_vm.options},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }